import { render, staticRenderFns } from "./JmMessage.vue?vue&type=template&id=b6343d52&scoped=true"
import script from "./JmMessage.vue?vue&type=script&lang=js"
export * from "./JmMessage.vue?vue&type=script&lang=js"
import style0 from "./JmMessage.vue?vue&type=style&index=0&id=b6343d52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6343d52",
  null
  
)

export default component.exports